module.exports = __webpack_public_path__ + "static/media/usa.36ab476e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/usa.svg
// module id = 114
// module chunks = 0